import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import {
  StyledText,
  StyledTextSub,
} from '../../../../components/StyledTypography';
import IconButton from '@mui/material/IconButton';
import { useTranslate } from '@im/react-localization';
import { useProgramDetailLoad } from '../../hooks/program-detail-load';
import {
  DeatilsResponse,
  useGetDealHeaderAttributes,
} from '../../hooks/deal-details';
import EditIcon from '@mui/icons-material/Edit';
import EditClaimItDialog from './EditClaimItDialog';
import { useDateTimeFormatter } from 'src/hooks/dateTimeFormatter';

interface DealDetailsPageClaimItHeaderProps {
  details?: DeatilsResponse;
}
export default function DealDetailsPageClaimItHeader(
  props: Readonly<DealDetailsPageClaimItHeaderProps>
) {
  const translate = useTranslate();
  const formatDateTime = useDateTimeFormatter();
  const GetDealHeaderAttributes = useGetDealHeaderAttributes({
    dealId: props.details?.deal_id,
  });
  const [searchParams] = useSearchParams();
  const countryCode = searchParams.get('countryCode');
  const programDetailResult = useProgramDetailLoad({
    countryCode: String(countryCode),
    vendorID: props.details?.vendor_id ?? 0,
    vendorprogramid: props.details?.vendor_program_id,
  });

  const [claimItDialog, setClaimItDialog] = useState<
    null | 'claimName' | 'claimOnDate'
  >(null);

  const programClaimName =
    programDetailResult?.data?.manualTemplatesFieldProperties.claimName ?? '';
  const claimName =
    GetDealHeaderAttributes?.data?.find(
      (item) => item.attributename === 'ClaimName'
    )?.attributevalue ?? programClaimName;

  const cliamOnDate = GetDealHeaderAttributes?.data?.find(
    (item) => item.attributename === 'ClaimOnDate'
  )?.attributevalue;

  return (
    <Stack direction="row" flexWrap="wrap">
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" />}
        spacing={2}
        width="100%"
      >
        <Stack>
          <StyledText
            fontWeight={600}
            style={{
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
              width: '70px',
              wordBreak: 'break-word',
            }}
          >
            {claimName != null && claimName !== '' ? claimName : '--'}
          </StyledText>
          <StyledTextSub data-testid="vp-claim-name-sub-text">
            {translate('VendorProgram.ProgramDetailClaimNameName')}
            {(!claimName || claimName === '') && (
              <IconButton
                data-testid="edit-claim-name"
                onClick={() => setClaimItDialog('claimName')}
                sx={(theme) => ({ padding: `0 ${theme.spacing(0.5)}` })}
              >
                <EditIcon
                  sx={(theme) => ({
                    color: theme.palette.primary[700],
                    fontSize: theme.typography.body1.fontSize,
                  })}
                />
              </IconButton>
            )}
          </StyledTextSub>
        </Stack>
        <Stack>
          <StyledText fontWeight={600}>
            {cliamOnDate ? formatDateTime(cliamOnDate) : `--`}
          </StyledText>
          <StyledTextSub>
            {translate('VendorDeals.ClaimItClaimOnDate')}
            <IconButton
              data-testid="edit-claim-on-date"
              onClick={() => setClaimItDialog('claimOnDate')}
              sx={(theme) => ({ padding: `0 ${theme.spacing(0.5)}` })}
            >
              <EditIcon
                sx={(theme) => ({
                  color: theme.palette.primary[700],
                  fontSize: theme.typography.body1.fontSize,
                })}
              />
            </IconButton>
          </StyledTextSub>
        </Stack>
      </Stack>
      {claimItDialog && (
        <EditClaimItDialog
          claimName={claimName}
          claimOnDate={cliamOnDate}
          details={props.details}
          field={claimItDialog}
          handleClose={() => setClaimItDialog(null)}
        />
      )}
    </Stack>
  );
}
